import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthsFacade } from '@kion/data-access/data-access-auths';
import { map, retry } from 'rxjs/operators';
import { Auth } from '@kion/data-models';

@Injectable({
  providedIn: 'root'
})
export class SecureRouteGuard implements CanActivate {

  constructor(private authsFacade: AuthsFacade, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authsFacade.all$.pipe(
      map(
        (auths: Auth[]) => {
          const auth = auths[0];
          if (!auth?.user ||  (new Date() > new Date(auth?.user?.expireDate))) {
            this.router.navigate(['']).then(() => { });
          }
          return true;
        }
      )
    );
  }

}
